































import {defineComponent, PropType} from "@vue/composition-api";
import FormSection from "@tool/Components/FormSection.vue";
import useFormHelper from "@tool/Helpers/useFormHelper";
import {TeamEntityInterface} from "@tool/tool.types";
import FormError from "@tool/Components/FormError.vue";
import {WithProps} from "@base/base.types";
import useAxios from "@tool/Helpers/useAxios";
import {useInertia} from "@tool/Helpers/useInertia";
import {useToast} from "vue-toastification/composition";
import useVuelidate from "@vuelidate/core";
import {helpers, minLength, required} from "@vuelidate/validators";

export default defineComponent({
    components: {
        FormSection,
        FormError,
    },
    props: {
        team: {
            type: Object as PropType<WithProps<TeamEntityInterface, 'owner_user'>>,
            required: true
        }
    },
    setup(props) {
        const toast = useToast();

        const form = useFormHelper({
            name: props.team.name
        });

        const formValidator = useVuelidate({
            name: {
                required,
                minLength: helpers.withMessage('Teams name must be at least 3 characters long', minLength(3))
            }
        }, form.value.data);

        const formHandle = async () => {
            const response = await form.value.submit((data) => {
                return useAxios().put<TeamEntityInterface>(route('app.team.settings.update', props.team.id), {
                    name: data.name
                })
            });

            if (response.success) {
                useInertia().get(route(route().current(), route().params), {}, {
                    preserveScroll: true,
                    onSuccess() {
                        toast.success('Teams name was successfully updated');
                    }
                })
            }
        }

        return {
            form,
            formValidator,
            formHandle,
        }
    }
});
